<template>
	<div class="home">
		<SectionIntro />
		<LazySectionAbout />
		<LazySectionAdvantages />
		<LazySectionEcosystem />
		<LazySectionSSP />
		<LazySectionMediakit />
		<LazySectionPartners :partners="mainPartners" style="top: -100px" />

	</div>
</template>

<script setup lang="ts">
	import { MAIN_PARTNERS } from '~/constants/partners'

	const mainPartners = MAIN_PARTNERS
	const preloaderStore = usePreloaderStore()
	const {$ScrollTrigger: ScrollTrigger} = useNuxtApp()

	onMounted(() => {
		if (import.meta.client) {
			nextTick(() => {
				window.scrollTo({ top: 0, behavior: 'instant' })

				if ('scrollRestoration' in window.history) {
					window.history.scrollRestoration = 'manual'
				}
			})
		}
	})

	// Следим за завершением прелоадера и скроллим к хешу если он есть
	watch(
		() => preloaderStore.isComplete,
		(isComplete) => {
			if (isComplete && import.meta.client) {
				const hash = window.location.hash
				if (hash) {
					setTimeout(() => {
						const element = document.querySelector(hash)
						if (element) {
							element.scrollIntoView({ behavior: 'smooth' })
						}
					}, 100)
				}
			}
		}
	)

	onMounted(() => {
		ScrollTrigger.refresh()
	})
</script>

